<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
    <div class="text-center">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3">Processing login...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthCallback",
  async mounted() {
    try {
      // Initialize Auth0 and handle the callback
      const isAuthenticated = await this.$store.dispatch('initAuth0');

      if (isAuthenticated) {
        // Redirect to races page after successful auth
        this.$router.push({ name: 'races' });
      } else {
        // If not authenticated, redirect to login
        this.$router.push({ name: 'login' });
      }
    } catch (error) {
      console.error('Auth0 callback error:', error);
      this.$store.dispatch('newMessage', {
        status: 'danger',
        message: 'Authentication failed. Please try again.'
      });
      this.$router.push({ name: 'login' });
    }
  }
};
</script>